import React, { useContext } from 'react';
import { MapWidgetRootStore } from './MapWidgetRootStore';

export const MapWidgetContext = React.createContext<
  MapWidgetRootStore | undefined
>(undefined);

export const useMapWidgetStore = (): MapWidgetRootStore => {
  const value = useContext(MapWidgetContext);

  if (!value) {
    throw new Error(
      'Невозможно получить значение контекста MapWidgetStore до его инициализации',
    );
  }

  return value;
};
